function addZero(numero) {
  if (numero <= 9) return `0${numero}`;
  else return numero;
}

function formatDateBrazilian(date, time = false) {
  if (!date) return "";

  if (isValidDateBrazilian(date)) {
    return date;
  }

  if (isValidDateAmerican(date)) {
    date = date.split("/");
    return `${date[2]}/${date[1]}/${date[0]}`;
  }

  const dateFormat = new Date(date);

  const year = addZero(dateFormat.getFullYear().toString());
  const month = addZero((dateFormat.getMonth() + 1).toString());
  const day = addZero(dateFormat.getDate().toString());

  if (time) {
    const hours = addZero(dateFormat.getHours().toString());
    const minutes = addZero(dateFormat.getMinutes().toString());
    const seconds = addZero(dateFormat.getSeconds().toString());

    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  }

  return `${day}/${month}/${year}`;
}

function formatDateAmerican(date) {
  if (!date) return "";

  if (isValidDateAmerican(date)) {
    return date;
  }

  if (isValidDateBrazilian(date)) {
    date = date.split("/");
    return `${date[2]}-${date[1]}-${date[0]}`;
  }

  const dateFormat = new Date(date);
  const year = addZero(dateFormat.getFullYear().toString());
  const month = addZero((dateFormat.getMonth() + 1).toString());
  const day = addZero(dateFormat.getDate().toString());

  return `${year}-${month}-${day}`;
}

function isValidDateAmerican(date) {
  try {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return date.match(regEx) != null;
  } catch (err) {
    return null;
  }
}

function isValidDateBrazilian(date) {
  try {
    const regEx = /^\d{2}-\d{2}-\d{4}$/;
    return date.replace(/\//g, "-").match(regEx) != null;
  } catch (err) {
    return null;
  }
}

module.exports = {
  formatDateAmerican,
  formatDateBrazilian,
  isValidDateAmerican,
};
